import styled from "styled-components";

export const Container = styled.div`
    display : flex;
    align-items : center;
    justify-content : center;    
`

export const PageWrapper = styled.div``

export const Page = styled.div`
    margin : 0 1rem;
    cursor : pointer;
`